import React, { useCallback } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { Typography } from "../Typography/Typography";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        flex: '1',
        minWidth: 150,
        padding: theme.spacing(0, 2),
        margin: 0,
        userSelect: 'none',
        cursor: 'pointer',
        transition: theme.transitions.duration.shorter + "ms",
        // 中身のテキストのずれ予防のため、枠線不要の場合も背景色と同じ枠線をつける。
        borderStyle: 'solid',
        borderWidth: theme.shape.borderWidth.normal + "px 0",
        borderColor: theme.palette.light.background.paper,
        backgroundColor: theme.palette.light.background.paper,
        color: theme.palette.primary.main,
        '&:hover:not(:active)': {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary[50],
            backgroundColor: theme.palette.primary[50],
        },
        '&:active': {
            color: theme.palette.dark.text.primary,
            borderColor: theme.palette.dark.text.primary,
            backgroundColor: theme.palette.primary.main,
        },
        '&:focus': {
            outline: 0,
        },
    },
    first: {
        borderTopLeftRadius: theme.shape.borderRadius - theme.shape.borderWidth.normal,
        borderBottomLeftRadius: theme.shape.borderRadius - theme.shape.borderWidth.normal,
        borderLeftWidth: theme.shape.borderWidth.normal,
    },
    last: {
        borderTopRightRadius: theme.shape.borderRadius - theme.shape.borderWidth.normal,
        borderBottomRightRadius: theme.shape.borderRadius - theme.shape.borderWidth.normal,
        borderRightWidth: theme.shape.borderWidth.normal,
    },
    selected: {
        pointerEvents: 'none',
        color: theme.palette.dark.text.primary,
        borderColor: theme.palette.light.background.paper,
        backgroundColor: theme.palette.primary.main,
        '&:hover:not(:active)': {
            color: theme.palette.dark.text.primary,
            borderColor: theme.palette.light.background.paper,
            backgroundColor: theme.palette.primary.main,
        },
    },
    disabled: {
        pointerEvents: 'none',
        color: theme.palette.light.action.disabled,
        borderColor: theme.palette.light.background.paper,
        backgroundColor: theme.palette.light.background.paper,
        '&$selected': {
            color: theme.palette.dark.text.primary,
            borderColor: theme.palette.light.background.paper,
            backgroundColor: theme.palette.light.action.disabled,
        },
    },
}); }, { name: 'SnTabButton' });
/**
 * タブ選択ボタン。TabButtonGroupで用いられることを想定。
 */
export var TabButton = function (props) {
    var _a;
    var id = props.id, onClick = props.onClick, selected = props.selected, first = props.first, last = props.last, disabled = props.disabled, name = props.name, className = props.className, style = props.style;
    var classes = useStyles(props);
    var handleClick = useCallback(function () {
        onClick(id);
    }, [id, onClick]);
    var buttonNameClass = classNames((_a = {},
        _a[classes.root] = true,
        _a[classes.first] = first,
        _a[classes.last] = last,
        _a[classes.selected] = selected,
        _a[classes.disabled] = disabled,
        _a), className);
    return (React.createElement("button", { className: buttonNameClass, onClick: handleClick, disabled: disabled, style: style },
        React.createElement(Typography, { variant: "body1", bold: true }, name)));
};
